import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "src/app-redux/hooks";
import { Link } from "react-router-dom";
import {
  Box,
  Link as MuiLink,
  Grid,
  Switch,
  Backdrop,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import { columns } from "./components/columns";
import { getPrintFile, searchData } from "src/app-redux/common-actions";
import { useStyles } from "./components/style";
import { NodCommercialRoute } from "../../nod-commercial.routes";
import {
  deleteCommercialPayement,
  getPaymentDetailsById,
  getPaymentTypesDropdownAction,
  voidCommercialPayement,
} from "src/app-redux/commercial/actions/commercialActions";
import {
  setSelectedPaymentId,
  selectLoader as commercialLoader,
  setAmountDue,
} from "src/app-redux/commercial/commercialSlice";
import Drawer from "./components/Drawer";
import DeleteIcon from "@material-ui/icons/Delete";
import BlockIcon from "@mui/icons-material/Block";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import { MoreVert, PrintSharp, Warning } from "@material-ui/icons";
import { loader as gateEntryLoader } from "src/app-redux/gate-entry/gateEntrySlice";
import { filteryByArr } from "src/common/utils/app.dropdowns";
import { filterBy } from "src/common/utils/helpers";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { Tooltip } from "@mui/material";
import DuplicateReceiptDialog from "src/components/AlertDialog/DuplicateReceiptDialog";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import CommonLoader from "src/components/Loader/CommonLoader";

const INVOICE_CLIMAX_URL = "http://10.14.20.11:5000";

interface Props {}

export function PaymentsList({}: Props): React.ReactElement {
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const classes = useStyles();
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const moduleName = NodCommercialRoute.title;
  const [paymentRecord, setpaymentRecord] = React.useState<GridRowModel[]>([]);
  const pageHeading = "Invoices";
  const [loader, setLoader] = useState<any>(false);
  const loader2: any = useAppSelector(commercialLoader);
  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const dispatch = useDispatch();
  const terminalPageLink = NodCommercialRoute.subRoutes
    ? `${NodCommercialRoute.path}${NodCommercialRoute?.subRoutes[0].path}`
    : "";
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const [isOpenDeleteDailog, setIsOpenDeleteDailog] = useState<boolean>(false);
  const [isOpenVoidDailog, setIsOpenVoidDailog] = useState<boolean>(false);
  const [deleteGridItem, setdeleteGridItem] = useState<any>("");
  const receiptLoader: any = useAppSelector(gateEntryLoader);
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);
  const [deleteRemarks, setDeleteRemarks] = useState("");
  const [isDeleteMode, setIsDeleteMode] = React.useState(false);
  const [listAction, setListAction] = useState<any>(null);
  const terminalType = Number(localStorage.getItem("terminalType"));
  const handleCloseDrawer = () => {
    handleSearch();
    setisDrawerOpen(false);
  };

  const handleClickActionBtn = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseActionBtn: () => void = () => {
    setAnchorEl(null);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteMode(false);
    setDeleteRemarks("");
    setIsOpenDeleteDailog(false);
  };
  const handleDeleteDialog = async () => {
    setIsDeleteMode(true);
    if (deleteRemarks) {
      setIsOpenDeleteDailog(false);
      if (deleteGridItem) {
        const body = { ...deleteGridItem, deleteRemarks: deleteRemarks };

        const res: any = await dispatch(deleteCommercialPayement(body));
        if (res.payload) {
          handleSearch();
        }
      }
    }
  };
  const handleCloseVoidDialog = () => {
    setIsDeleteMode(false);
    setDeleteRemarks("");
    setIsOpenVoidDailog(false);
  };
  const handleVoidDialog = async () => {
    setIsOpenVoidDailog(false);
    const res: any = await dispatch(voidCommercialPayement(listAction?.paymentId));
    if (res.payload) {
      handleSearch();
    }
  };

  const handleDelete = (id: any) => {
    setIsOpenDeleteDailog(true);
    setdeleteGridItem(id);
  };

  const handleVoid = (id: any) => {
    setIsOpenVoidDailog(true);
  };

  useEffect(() => {
    if (paymentRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "serialNumber"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <>
                    <MuiLink
                      className="customMuiLink"
                      onClick={() => {
                        dispatch(getPaymentDetailsById(row.original.paymentId));
                        dispatch(
                          setSelectedPaymentId({
                            paymentId: row.original.paymentId,
                            regNo: row.original.registrationNumber,
                            paymentStatus: row.original.paymentStatus,
                            containerNo: row.original.containerNo,
                            virNumber: row.original.virNo,
                            indexNumber: row.original.indexNo,
                          })
                        );
                        dispatch(
                          setAmountDue(row.original.netAmount - row.original.totalPaymentReceived)
                        );
                        dispatch(getPaymentTypesDropdownAction());
                        setisDrawerOpen(true);
                      }}
                    >
                      {row.original.serialNumber ? row.original.serialNumber : "-"}
                    </MuiLink>
                  </>
                );
              },
            }
          : column.accessorKey === "vehicleStatus"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <>
                    <Box
                      className={`${
                        row.original.vehicleStatus === "Checked-out" ? "label-green" : ""
                      }`}
                    >
                      {row.original.vehicleStatus}
                    </Box>
                  </>
                );
              },
            }
          : column.accessorKey === "nomination"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue }: any) {
                return (
                  <Tooltip title={renderedCellValue} followCursor>
                    <span>{renderedCellValue}</span>
                  </Tooltip>
                );
              },
            }
          : column.accessorKey === "totalPayment"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return ` ${
                  row.original.totalPayment ? row.original.currency.toUpperCase() || "PKR " : ""
                } ${
                  row.original.totalPayment
                    ? row.original.totalPayment.toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })
                    : ""
                }`;
              },
            }
          : column.accessorKey === "netAmount"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return ` ${
                  row.original?.netAmount ? row.original.currency.toUpperCase() || "PKR " : " "
                } ${
                  row.original?.netAmount
                    ? row.original?.netAmount?.toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })
                    : ""
                }`;
              },
            }
          : column.accessorKey === "sTaxAmount"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return ` ${
                  row.original?.sTaxAmount ? row.original.currency.toUpperCase() || "PKR " : ""
                } ${
                  row.original?.sTaxAmount
                    ? row.original?.sTaxAmount?.toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })
                    : ""
                }`;
              },
            }
          : column.accessorKey === "discount"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return ` ${
                  row.original?.discount ? row.original.currency.toUpperCase() || "PKR " : ""
                } ${
                  row.original?.discount
                    ? row.original?.discount?.toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })
                    : ""
                }`;
              },
            }
          : column.accessorKey === "totalPaymentReceived"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return ` ${
                  row.original.totalPaymentReceived
                    ? row.original.currency.toUpperCase() || "PKR "
                    : ""
                } ${
                  row.original.totalPaymentReceived
                    ? row.original.totalPaymentReceived.toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })
                    : ""
                }`;
              },
            }
          : column.accessorKey === "remarks"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue }: any) {
                return (
                  <Tooltip title={renderedCellValue} followCursor>
                    <span>{renderedCellValue}</span>
                  </Tooltip>
                );
              },
            }
          : column.accessorKey === "actionButtons"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return row.original.paymentStatus == "Void" ? (
                  <>
                    <Tooltip title={"This entry has been marked as void."} placement="bottom-start">
                      <span className={classes.customButton}>
                        <NewCommonButton
                          style={{ minWidth: "30px", padding: "4px" }}
                          icon={<Warning />}
                        >
                          {/* Marked as Wrong Entry */}
                        </NewCommonButton>
                      </span>
                    </Tooltip>
                  </>
                ) : (
                  <React.Fragment>
                    <Box>
                      <Tooltip title="More">
                        <Button
                          onClick={(e) => {
                            setListAction(row.original);
                            handleClickActionBtn(e);
                          }}
                          disabled={row.original?.paymentStatus == "Void"}
                          aria-controls={open ? "account-menu" : undefined}
                          aria-haspopup="true"
                          aria-expanded={open ? "true" : undefined}
                          style={{ minWidth: "30px", padding: "4px" }}
                        >
                          <MoreVert />
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [paymentRecord]);

  const formik = useFormik({
    initialValues: {
      inProgressVehiclesDataOnly: true,
      filterBy: "today",
      vehicleStatusId: 10,
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
    },
    onSubmit: () => {
      // handleSearch();
    },
  });
  const { values, setValues } = formik;
  const handleSearch = async () => {
    const { filterBy, startDate, endDate, inProgressVehiclesDataOnly } = values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      inProgressVehiclesDataOnly: inProgressVehiclesDataOnly || false,
    };
    setpaymentRecord([]);
    setLoader(true);
    try {
      const results: any = await dispatch(searchData("/get-all-payments", JSON.stringify(body)));
      const apiRecord = results;
      if (apiRecord) {
        const transformedData = apiRecord.map((data: any) => {
          return { ...data, id: data.paymentId ? data.paymentId : Math.random() };
        });
        setpaymentRecord(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };
  const [resetHandler, setResetHandler] = useState(false);

  const resetSearch = () => {
    setValues(formik.initialValues);
    setIsCustomDate(false);
    setResetHandler(true);
  };
  useEffect(() => {
    formik.setFieldValue("filterBy", "today");
    handleSearch();
    setResetHandler(false);
  }, [resetHandler]);
  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
      }
      formik.setFieldValue("startDate", res?.startDate);
      formik.setFieldValue("endDate", res?.endDate);
    }
  };

  const [isOpenPrintDailog, setIsOpenPrintDailog] = useState<boolean>(false);
  const [printType, setPrintType] = useState<any>(0);
  const [selectedRecordId, setSelectedRecordId] = useState(null);

  const printReceipt = async (isDuplicate: string) => {
    const isDp = terminalType === 4;
    const isNod = terminalType !== 4;
    setIsOpenPrintDailog(false);
    const dateTime = moment().format("DD MMM YYYY, HH:mm");
    if (printType === 1) {
      const fileMetaData = {
        url: `${process.env.REACT_APP_API_URL}/get-commercial-slip-by-gate-pass-id/${selectedRecordId}?isDuplicate=${isDuplicate}&printDateTime=${dateTime}&isNod=${isNod}&isDp=${isDp}`,
        contentType: ".pdf",
        fileName: "testPdf.pdf",
      };
      await dispatch(getPrintFile(fileMetaData, dispatch));
      return;
    }
    if (printType === 2) {
      const fileMetaData = {
        url: `${process.env.REACT_APP_API_URL}/get-delivery_order_by_payment_id/${selectedRecordId}?isDuplicate=${isDuplicate}&index=${listAction?.indexNo}&containerNumber=${listAction?.containerNo}&virNumber=${listAction?.virNo}`,
        contentType: ".pdf",
        fileName: "testPdf.pdf",
      };
      await dispatch(getPrintFile(fileMetaData, dispatch));
      return;
    }
    if (printType === 3) {
      if (terminalType === 4) {
        // DP Gate Pass Print endpoint
        const fileMetaData = {
          url: `${process.env.REACT_APP_API_URL}/get-dp-gate-pass-invoice-print/${
            listAction?.gatePassId
          }?isDuplicate=${isDuplicate}&gatePassPaymentId=${selectedRecordId}&vehicleNo=${
            listAction?.registrationNumber || ""
          }&PrintDateTime=${dateTime}`,
          contentType: ".pdf",
          fileName: "testPdf.pdf",
        };
        await dispatch(getPrintFile(fileMetaData, dispatch));
        return;
      } else {
        // Original Gate Pass Print endpoint
        const fileMetaData = {
          url: `${process.env.REACT_APP_API_URL}/get-gate-pass-invoice-print/${listAction?.gatePassId}?isDuplicate=${isDuplicate}&indexNo=${listAction?.indexNo}&virNo=${listAction?.virNo}&gatePassPaymentId=${selectedRecordId}`,
          contentType: ".pdf",
          fileName: "testPdf.pdf",
        };
        await dispatch(getPrintFile(fileMetaData, dispatch));
        return;
      }
    }
  };

  const exportHandler = async (row: any) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );
    const exportedRecords = await row?.map((data: any) => {
      return {
        "Serial #": data?.serialNumber,
        Vehicle: data?.registrationNumber,
        Driver: data?.driverName,
        Type: data?.vehicleType,
        Status: data?.vehicleStatus,
        Weight: `${data?.weight?.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })} ${data.weightUnit ? data.weightUnit : "KG"}`,
        "Type of Payments": data?.paymentTypes,
        "Total Payment": `PKR ${data?.totalPayment?.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })}`,
        "Net Amount": `PKR ${data?.netAmount?.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })}`,
        "Tax Amount": `PKR ${data?.sTaxAmount?.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })}`,
        Discount: `PKR ${data?.discount?.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })}`,
        "Payment Received": `PKR ${data?.totalPaymentReceived?.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })}`,
        "Payment Status": data?.paymentStatus,
        Consignment: data?.consignmentType,
        "GD #": data?.consignmentType,
        Remarks: data?.remarks,
      };
    });
    return exportedRecords;
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader2 || receiptLoader}>
        <CommonLoader />
      </Backdrop>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        className={classes.menu}
        onClose={handleCloseActionBtn}
        onClick={handleCloseActionBtn}
      >
        <MenuItem
          onClick={() => {
            setPrintType(1); // 1 for invoice
            setSelectedRecordId(listAction?.paymentId);
            setIsOpenPrintDailog(true);
            handleCloseActionBtn();
          }}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "#1976d2" }}>
            <PrintSharp fontSize="small" />
          </ListItemIcon>
          Print Invoice
        </MenuItem>
        <>
          {/* Delivery Order - NOT for terminalType 4 */}
          {terminalType !== 4 && (
            <MenuItem
              onClick={() => {
                setPrintType(2); // 2 for delivery order
                setSelectedRecordId(listAction?.paymentId);
                setIsOpenPrintDailog(true);
                handleCloseActionBtn();
              }}
              disabled={listAction?.paymentStatus !== "Paid"}
            >
              <ListItemIcon style={{ minWidth: "40px", color: "#1976d2" }}>
                <PrintSharp fontSize="small" />
              </ListItemIcon>
              Print Delivery Order
            </MenuItem>
          )}

          {/* Gate Pass - allowed for terminalType 4 */}
          <MenuItem
            onClick={() => {
              setPrintType(3); // 3 for gate pass
              setSelectedRecordId(listAction?.paymentId);
              setIsOpenPrintDailog(true);
              handleCloseActionBtn();
            }}
            disabled={listAction?.paymentStatus !== "Paid"}
          >
            <ListItemIcon style={{ minWidth: "40px", color: "#1976d2" }}>
              <PrintSharp fontSize="small" />
            </ListItemIcon>
            Print Gate Pass
          </MenuItem>
        </>

        <MenuItem
          onClick={() => {
            handleDelete(listAction);
            handleCloseActionBtn();
          }}
          // disabled={listAction?.vehicleStatus == "Checked-out"}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "red" }}>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          Delete
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleVoid(listAction);
            handleCloseActionBtn();
          }}
          // disabled={listAction?.vehicleStatus == "Checked-out"}
        >
          <ListItemIcon style={{ minWidth: "40px", color: "red" }}>
            <BlockIcon fontSize="small" />
          </ListItemIcon>
          Mark as Void
        </MenuItem>
      </Menu>

      {/* Dialog for Print Receipt */}
      <DuplicateReceiptDialog
        isOpen={isOpenPrintDailog}
        handleOriginal={() => {
          printReceipt("0");
        }}
        heading={"Confirmation"}
        handleDuplicate={() => {
          printReceipt("1");
        }}
        onClose={() => {
          setIsOpenPrintDailog(false);
        }}
      >
        Which receipt do you want to print?
      </DuplicateReceiptDialog>

      <CommonDataGridPage
        module={moduleName}
        heading={pageHeading}
        GridDataComp={
          <CommonMaterialGrid
            rows={paymentRecord}
            columns={displayColumns}
            loader={loader}
            defaultPerPageRecord={15}
            height={550}
            isExport={isExport}
            deletedRow={true}
            exportHandler={exportHandler}
            filename={`Commercial_payment_list_${Date.now()}`}
          />
        }
      >
        <>
          <Grid spacing={2} container direction="row">
            <Grid item xs={12} md={3} lg={2}>
              <CommonAutoCompleteField
                cssClassName="customTextField"
                error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
                helperText={formik.touched.filterBy && formik.errors.filterBy}
                label="Filter by"
                placeholder="Filter by"
                name="filterBy"
                disableClearable={true}
                optionsType={filteryByArr}
                getOptionLabel={(option: any) => option.label || null}
                onChange={(row: any) => {
                  row ? setValues({ ...values, filterBy: row.value || "" }) : "";
                  if (row === null) {
                    formik.setFieldValue("filterBy", null);
                  }
                  filterByAction(row);
                }}
                value={
                  filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""
                }
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2} className={!isCustomDate ? classes.hideDatesGrid : ""}>
              <CommonTextFieldDate
                cssClassName="customTextField"
                label={"Start Date"}
                name={"startDate"}
                datePickerRef={startDatePickerRef}
                value={formik.values.startDate}
                onChange={(e: any) => {
                  formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                  formik.setFieldValue("endDate", "");
                }}
                maxDate={moment().format("YYYY-MM-DDTHH:mm")}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2} className={!isCustomDate ? classes.hideDatesGrid : ""}>
              <CommonTextFieldDate
                cssClassName="customTextField"
                label={"End Date"}
                name={"endDate"}
                datePickerRef={endDatePickerRef}
                value={formik.values.endDate}
                onChange={(e: any) => {
                  formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
                }}
                minDate={formik.values.startDate}
                maxDate={moment().format("YYYY-MM-DDTHH:mm")}
              />
            </Grid>
            <Grid item xs={12} md={isCustomDate ? 3 : 4} lg={2} style={{ paddingRight: 0 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={Boolean(formik.values.inProgressVehiclesDataOnly)}
                    onChange={formik.handleChange}
                    name="inProgressVehiclesDataOnly"
                    color="primary"
                  />
                }
                label="In Progress Vehicles"
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={isCustomDate ? 12 : 5}
              lg={isCustomDate ? 4 : 8}
              direction="row"
              // justify-content="flex-end"
              // alignItems="flex-end"
            >
              <Box
                textAlign="right"
                mt={1}
                mb={1}
                className="terminalChargesSearchBtns"
                style={{ float: "right" }}
              >
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                  Reset
                </CommonButton>
                <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
                  Search
                </CommonButton>
                {terminalType !== 4 && (
                  <NewCommonButton
                    cssClass="customSubmitBtn"
                    mr0={true}
                    style={{ marginLeft: "10px" }}
                    onClick={() =>
                      window.open(
                        INVOICE_CLIMAX_URL,
                        "_blank",
                        "width=1300,height=600,left=150,top=100"
                      )
                    }
                  >
                    Old System Data
                  </NewCommonButton>
                )}
                <MuiLink
                  to={terminalPageLink}
                  component={Link}
                  style={{ textDecoration: "none", marginBottom: "8px" }}
                >
                  <NewCommonButton
                    cssClass="customSubmitBtn"
                    isEdit={true}
                    mr0={true}
                    style={{ marginLeft: "10px" }}
                  >
                    Add Terminal Charges
                  </NewCommonButton>
                </MuiLink>
              </Box>
            </Grid>
          </Grid>
        </>
      </CommonDataGridPage>
      <TransitionDialog
        isOpen={isOpenDeleteDailog}
        handleClose={handleCloseDeleteDialog}
        heading={"Confirmation"}
        handleConfirm={handleDeleteDialog}
      >
        Are you sure you want to delete this record?
        <Box style={{ marginTop: "10px", marginBottom: "10px" }}>
          <TextField
            required
            multiline
            rows={1}
            rowsMax={5}
            size="small"
            fullWidth
            className="customTextField"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            label="Remarks"
            name="remarks"
            id="remarks"
            placeholder="Enter Remarks"
            disabled={false}
            value={deleteRemarks}
            onChange={(e) => {
              const { value } = e.target;
              setDeleteRemarks(value);
            }}
            error={isDeleteMode && !deleteRemarks}
            helperText={isDeleteMode && !deleteRemarks && "This field is required"}
          />
        </Box>
      </TransitionDialog>
      <TransitionDialog
        isOpen={isOpenVoidDailog}
        handleClose={handleCloseVoidDialog}
        heading={"Confirmation"}
        handleConfirm={handleVoidDialog}
      >
        Are you sure you want to void this record?
      </TransitionDialog>
    </>
  );
}
